var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.listed
        ? _vm._t("list", [
            _c("media-list", {
              ref: "media-list",
              attrs: {
                "show-delete": !_vm.displayOnly,
                medias: _vm.existingAttachments
              },
              on: { "delete-media": _vm.removeAttachment }
            })
          ])
        : _vm._e(),
      !_vm.displayOnly
        ? _c(
            "vue-dropzone",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "schedule_events.attachment.put",
                  expression: "'schedule_events.attachment.put'"
                }
              ],
              ref: "dropzone",
              attrs: {
                id: "upload",
                "use-font-awesome": true,
                options: _vm.dropzoneOptions,
                "use-custom-dropzone-options": true,
                "validation-allowed-extensions": [
                  ".pdf",
                  ".docx",
                  ".doc",
                  ".xls",
                  ".xlsx",
                  ".ppt",
                  ".pptx",
                  ".jpg",
                  ".jpeg",
                  ".png",
                  ".gif",
                  ".bmp",
                  ".tiff"
                ],
                maxNumberOfFiles: 1,
                useCustomSlot: true
              },
              on: {
                "vdropzone-success": _vm.successSendFormWithFile,
                "vdropzone-sending": _vm.sendFormWithFile,
                "vdropzone-error": _vm.dropzoneErrorHandler,
                "vdropzone-file-added": _vm.fileAdded,
                "vdropzone-queue-complete": _vm.complete
              }
            },
            [
              _c(
                "div",
                { staticClass: "dropzone-custom-content" },
                [
                  _vm._v(" Arraste e solte para enviar um arquivo "),
                  _c("p", { staticClass: "separator" }, [
                    _c("span", { staticClass: "separator-span" }, [
                      _vm._v(" ou ")
                    ])
                  ]),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn waves-effect outline-primary",
                      attrs: { type: "button", variant: "outline-secondary" }
                    },
                    [_vm._v("Selecionar")]
                  )
                ],
                1
              ),
              _vm.$refs.dropzone
                ? _vm._t("meta", null, {
                    dropzone: _vm.$refs.dropzone,
                    processQueue: _vm.$refs.dropzone.processQueue,
                    fileCount: _vm.$refs.dropzone.getQueuedFiles().length
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }